var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"node-plugins-table\">\n<h4>Installed Plugins</h4>\n<table class=\"table table-condensed table-hover table-striped\">\n<tbody>\n<tr ng-repeat=\"data in nodePluginsTableCtrl.plugins\">\n<td>{{data.name}}</td>\n<td>v{{data.version}}</td>\n<td>{{data.description}}</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="components/node-plugins-table/node-plugins-table.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/node-plugins-table/node-plugins-table.template.html
// module id = 928
// module chunks = 0